module.exports = __webpack_public_path__ + "img/client-place-des-arts.03bf3fec.png";